<template>
  <div class="products-chart-wrapper" id="productsChartWrapper">
    <h3 class="text-accent center">{{ $t('products-chart-title') }}</h3>
    <h3 class="text-accent center">{{ $t('products-chart-title-2') }}</h3>
    <div class="products-chart-container">
      <div class="products-chart">
        <h3 class="text-light side-title">{{ $t('products-chart-side-1')}}</h3>
        <canvas id="productsChart"></canvas>
      </div>
    </div>
    <div class="products-chart-toggle-group">
      <div class="products-chart-toggle-wrapper">
        <h3 class="text-light side-title">{{ $t('products-chart-side-2')}}</h3>
        <div
          class="slider"
          :style="{ left: `${ active * 20 }%`}"
          :class="{
            'slider-zn' : active === 0,
            'slider-pb' : active === 1,
            'slider-cd' : active === 2,
            'slider-ag' : active === 3,
            'slider-au' : active === 4
          }"
        ></div>
        <!-- Zn -->
        <div class="products-chart-toggle zn" @click="changeElement(0)">
          <div class="ch-el">
            <span class="text-zn">{{ $t('zn') }}</span>
            <Chemical :el="'zn'"/>
          </div>
          <p>
            75,150
            <span>{{ $t('t') }}</span>
          </p>
        </div>
        <!-- Pb -->
        <div class="products-chart-toggle pb" @click="changeElement(1)">
          <div class="ch-el">
            <span class="text-pb">{{ $t('pb') }}</span>
            <Chemical :el="'pb'"/>
          </div>
          <p>
            71,697
            <span>{{ $t('t') }}</span>
          </p>
        </div>
        <!-- Cd -->
        <div class="products-chart-toggle cd" @click="changeElement(2)">
          <div class="ch-el">
            <span class="text-cd">{{ $t('cd') }}</span>
            <Chemical :el="'cd'"/>
          </div>
          <p>
            283,4
            <span>{{ $t('t') }}</span>
          </p>
        </div>
        <!-- Ag -->
        <div class="products-chart-toggle ag" @click="changeElement(3)">
          <div class="ch-el">
            <span class="text-ag">{{ $t('ag') }}</span>
            <Chemical :el="'ag'"/>
          </div>
          <p>
            41,315
            <span>{{ $t('kg') }}</span>
          </p>
        </div>
        <!-- Au -->
        <div class="products-chart-toggle au" @click="changeElement(4)">
          <div class="ch-el">
            <span class="text-au">{{ $t('au') }}</span>
            <Chemical :el="'au'"/>
          </div>
          <p>
            296,19
            <span>{{ $t('kg') }}</span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Chart from "chart.js";
import Chemical from "./individuals/shared/Chemical";
export default {
  components: {
    Chemical
  },
  data() {
    return {
      active: 0,
      interval: 5000,
      rotation: null,
      chart: null,
      charts: [
        // Zn
        {
          labels: [
            2010,
            2011,
            2012,
            2013,
            2014,
            2015,
            2016,
            2017,
            2018,
            2019,
            2020
          ],
          data: [
            73558,
            66550.8,
            78646.8,
            83550,
            78150,
            78692.4,
            76544.4,
            81733.2,
            82959.6,
            82045.2,
            76928.4
          ],
          color: "#67AAAE",
          colorBg: ["rgba(103, 170, 174, 0.2)"]
        },
        // Pb
        {
          labels: [
            2010,
            2011,
            2012,
            2013,
            2014,
            2015,
            2016,
            2017,
            2018,
            2019,
            2020
          ],
          data: [
            65000,
            65125,
            65577,
            68371,
            55459,
            65539,
            69625,
            64107,
            63787,
            68111,
            69133
          ],
          color: "#F58220",
          colorBg: ["rgba(252, 191, 138, 0.2)"]
        },
        // Cb
        {
          labels: [
            2010,
            2011,
            2012,
            2013,
            2014,
            2015,
            2016,
            2017,
            2018,
            2019,
            2020
          ],
          data: [360, 280, 300, 310, 380, 330, 330, 400, 420, 380, 400],
          color: "#8186B5",
          colorBg: ["rgba(211, 213, 230, 0.2)"]
        },
        // Ag
        {
          labels: [
            2010,
            2011,
            2012,
            2013,
            2014,
            2015,
            2016,
            2017,
            2018,
            2019,
            2020
          ],
          data: [52, 50, 50, 52, 65, 67, 80, 70, 75, 60, 70],
          color: "#A8A8A8",
          colorBg: ["rgba(219, 220, 220, 0.2)"]
        },
        // Au
        {
          labels: [
            2010,
            2011,
            2012,
            2013,
            2014,
            2015,
            2016,
            2017,
            2018,
            2019,
            2020
          ],
          data: [360, 220, 300, 310, 480, 330, 330, 400, 460, 370, 410],
          color: "#D5AB45",
          colorBg: ["rgba(229, 201, 142, 0.2)"]
        }
      ]
    };
  },
  methods: {
    newChart() {
      const ctx = document.getElementById("productsChart");
      this.chart = new Chart(ctx, {
        type: "line",
        data: {
          labels: this.charts[this.active].labels,
          datasets: [
            {
              data: this.charts[this.active].data,
              pointBackgroundColor: "#0a1f54",
              pointBorderColor: this.charts[this.active].color,
              pointBorderWidth: 2,
              borderColor: this.charts[this.active].color,
              backgroundColor: this.charts[this.active].colorBg
            }
          ]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          elements: {
            line: {
              tension: 0.000001
            }
          },
          fill: false,
          legend: {
            display: false
          },
          scales: {
            yAxes: [
              {
                gridLines: {
                  color: "rgba(23, 149, 208, 0.32)",
                  drawBorder: false
                },
                ticks: {
                  beginAtZero: true
                }
              }
            ],
            xAxes: [
              {
                gridLines: {
                  drawBorder: false,
                  borderDash: [4, 2],
                  color: "rgba(23, 149, 208, 0.32)"
                }
              }
            ]
          }
        }
      });
    },
    changeElement(n) {
      if (this.active !== n) {
        this.stopRotation();
        this.active = n;
        this.chart.data.labels = this.charts[this.active].labels;
        this.chart.data.datasets[0].data = this.charts[this.active].data;
        (this.chart.data.datasets[0].pointBorderColor = this.charts[
          this.active
        ].color),
          (this.chart.data.datasets[0].borderColor = this.charts[
            this.active
          ].color),
          (this.chart.data.datasets[0].backgroundColor = this.charts[
            this.active
          ].colorBg),
          this.chart.update();
        this.startRotation();
      }
    },
    startRotation() {
      this.rotation = setInterval(() => {
        if (this.active < 4) {
          this.changeElement(this.active + 1);
        } else {
          this.changeElement(0);
        }
      }, this.interval);
    },
    stopRotation() {
      clearInterval(this.rotation);
    }
  },
  mounted() {
    Chart.defaults.global.animation.duration = 1000;
    Chart.defaults.global.animation.easing = "easeInOutQuart";
    this.newChart();

    this.startRotation();
  },
  destroyed() {
    this.stopRotation();
  }
};
</script>

<style lang="scss" scoped>
.products-chart-wrapper {
  @extend %flex-center;
  background-color: $bgColor1;
  flex-direction: column;
  padding: 100px 0 50px;
  h3 {
    margin: 5px 0;
  }
  .products-chart-container {
    width: 100%;
  }
  .products-chart {
    margin: 50px auto;
    height: 25vw;
    position: relative;
    width: 80%;
  }
  .products-chart-toggle-group {
    background-color: rgba(255, 255, 255, 0.05);
    padding: 0 10%;
    width: 100%;
    .products-chart-toggle-wrapper {
      @extend %flex-center;
      align-items: flex-start;
      height: 200px;
      position: relative;
      width: 100%;
      .products-chart-toggle {
        @extend %flex-center;
        align-items: flex-end;
        cursor: pointer;
        flex-direction: column;
        justify-content: space-around;
        height: 100%;
        padding: 20px;
        width: 20%;
        .ch-el {
          @extend %flex-center;
          align-items: flex-end;
          justify-content: flex-end;
          margin-bottom: 10px;
          width: 100%;
          > span {
            font-size: 24px;
            font-weight: 700;
          }
        }
        > p {
          @extend %flex-center;
          align-items: flex-end;
          color: $mainTextLight;
          font-size: 59px;
          line-height: 40px;
          span {
            color: #98a7b9;
            font-size: 13px;
            line-height: 13px;
            margin-left: 3px;
          }
        }
      }
      .products-chart-toggle:hover {
        background-color: rgba(255, 255, 255, 0.01);
      }
      .slider {
        background-color: rgba(255, 255, 255, 0.05);
        height: 100%;
        left: 0;
        position: absolute;
        top: 0;
        @include transition(all 1s $mainCubic);
        width: 20%;
        z-index: 1;
      }
      .slider::before {
        background-color: rgba(255, 255, 255, 0.05);
        content: "";
        height: 5px;
        left: 0;
        position: absolute;
        top: -10px;
        @include transition(all 1s $mainCubic);
        width: 100%;
      }
      .slider::after {
        border-color: transparent transparent rgba(255, 255, 255, 0.05)
          transparent;
        border-style: solid;
        border-width: 0 10px 10px 10px;
        content: "";
        height: 10px;
        left: 50%;
        position: absolute;
        top: -20px;
        @include transition(all 1s $mainCubic);
        @include transform(translateX(-50%));
        width: 10px;
      }
      .slider-zn {
        background-color: rgba(103, 170, 174, 0.2);
      }
      .slider-zn::before {
        background-color: $znLight;
      }
      .slider-zn::after {
        border-color: transparent transparent $znLight transparent;
      }
      .slider-pb {
        background-color: rgba(252, 191, 138, 0.2);
      }
      .slider-pb::before {
        background-color: $pbLight;
      }
      .slider-pb::after {
        border-color: transparent transparent $pbLight transparent;
      }
      .slider-cd {
        background-color: rgba(211, 213, 230, 0.2);
      }
      .slider-cd::before {
        background-color: $cdLight;
      }
      .slider-cd::after {
        border-color: transparent transparent $cdLight transparent;
      }
      .slider-ag {
        background-color: rgba(219, 220, 220, 0.2);
      }
      .slider-ag::before {
        background-color: $agLight;
      }
      .slider-ag::after {
        border-color: transparent transparent $agLight transparent;
      }
      .slider-au {
        background-color: rgba(229, 201, 142, 0.2);
      }
      .slider-au::before {
        background-color: $auLight;
      }
      .slider-au::after {
        border-color: transparent transparent $auLight transparent;
      }
    }
  }
  .side-title {
    position: absolute;
    left: -5%;
    margin: 0;
    top: 50%;
    text-orientation: mixed;
    @include transform(rotate(180deg) translateX(-50%) translateY(50%));
    white-space: nowrap;
    writing-mode: vertical-rl;
  }
}
@media screen and (max-width: 1440px) {
  .products-chart-wrapper {
    .products-chart-toggle-group {
      .products-chart-toggle-wrapper {
        .products-chart-toggle {
          > p {
            font-size: 42px;
            line-height: 30px;
          }
        }
      }
    }
  }
}
@media screen and (max-width: 1280px) {
  .products-chart-wrapper {
    .products-chart-toggle-group {
      .products-chart-toggle-wrapper {
        height: 170px;
        .products-chart-toggle {
          .ch-el {
            > span {
              font-size: 16px;
            }
          }
          > p {
            font-size: 32px;
            line-height: 30px;
          }
        }
      }
    }
  }
}
@media screen and (max-width: 1000px) {
  .products-chart-wrapper {
    padding: 50px 0;
    h3 {
      font-size: 10px;
      letter-spacing: 1.5px;
      line-height: 15px;
      margin: 0;
      width: 90%;
    }
    .side-title {
      display: none;
    }
    .products-chart {
      width: 90%;
    }
    .products-chart-toggle-group {
      padding: 0 5%;
      .products-chart-toggle-wrapper {
        .products-chart-toggle {
          .ch-el {
            align-items: center;
            flex-direction: column;
            justify-content: center;
            .el {
              margin: 0;
            }
            span {
              display: block;
              font-size: 14px;
              margin-bottom: 10px;
              text-align: center;
            }
          }
          > p {
            font-size: 24px;
            line-height: 28px;
            span {
              font-size: 8px;
            }
          }
        }
      }
    }
  }
}
@media screen and (max-width: 800px) {
  .products-chart-wrapper {
    .products-chart-toggle-group {
      .products-chart-toggle-wrapper {
        .products-chart-toggle {
          align-items: center;
          .ch-el {
            span {
              display: block;
              font-size: 14px;
              margin-bottom: 10px;
              text-align: center;
            }
          }
          > p {
            font-size: 16px;
            line-height: 20px;
            span {
              font-size: 7px;
            }
          }
        }
      }
    }
  }
}
@media screen and (max-width: 600px) {
  .products-chart-wrapper {
    .products-chart {
      height: 50vw;
    }
    .products-chart-toggle-group {
      .products-chart-toggle-wrapper {
        height: 150px;
        .products-chart-toggle {
          align-items: center;
          .ch-el {
            span {
              display: block;
              font-size: 14px;
              margin-bottom: 10px;
              text-align: center;
            }
          }
          > p {
            font-size: 16px;
            line-height: 20px;
            span {
              font-size: 7px;
            }
          }
        }
      }
    }
  }
}
@media screen and (max-width: 420px) {
  .products-chart-wrapper {
    h3 {
      font-size: 9px;
      line-height: 12px;
    }
    .products-chart-toggle-group {
      .products-chart-toggle-wrapper {
        height: 150px;
        .products-chart-toggle {
          .ch-el {
            span {
              font-size: 11px;
            }
          }
          > p {
            font-size: 13px;
            line-height: 18px;
            span {
              font-size: 6px;
            }
          }
        }
      }
    }
  }
}
</style>
